import { format } from "date-fns";

const PLAIN_DATE_PATTERN = /^\d{4}-\d{2}-\d{2}$/;

export function parseDatePreservingCalendar(value?: string | Date | null): Date | null {
    if (!value) return null;

    if (value instanceof Date) {
        return Number.isNaN(value.getTime()) ? null : value;
    }

    if (PLAIN_DATE_PATTERN.test(value)) {
        const [year, month, day] = value.split('-').map(Number);
        const parsed = new Date(year, month - 1, day);
        return Number.isNaN(parsed.getTime()) ? null : parsed;
    }

    const parsed = new Date(value);
    return Number.isNaN(parsed.getTime()) ? null : parsed;
}

export function formatDateInputValue(date: Date): string {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
}

// Eg. 20 June 2025
export function formatUploadDate(isoString: string): string {
    const date = parseDatePreservingCalendar(isoString);
    if (!date) return '';
    const options: Intl.DateTimeFormatOptions = {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
    };
    return date.toLocaleDateString('en-US', options);
}

export function formatDate(dateStr: string): string {
    const date = parseDatePreservingCalendar(dateStr);
    return date ? format(date, "MMMM d, yyyy") : '';
}

export function formatDateNum(dateString: string): string {
    const date = parseDatePreservingCalendar(dateString);
    if (!date) return '';
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const year = String(date.getFullYear()).slice(-2);
    return `${month}/${day}/${year}`;
}

/** Short relative time for sync status (e.g. "Synced • 1m ago"). */
export function formatRelativeTimeAgo(isoString?: string | null): string {
    if (!isoString) return '';
    const then = new Date(isoString).getTime();
    if (Number.isNaN(then)) return '';
    const sec = Math.max(0, Math.floor((Date.now() - then) / 1000));
    if (sec < 60) return `${sec}s ago`;
    const min = Math.floor(sec / 60);
    if (min < 60) return `${min}m ago`;
    const hr = Math.floor(min / 60);
    if (hr < 48) return `${hr}h ago`;
    const day = Math.floor(hr / 24);
    if (day < 14) return `${day}d ago`;
    return formatUploadDate(isoString);
}
